import redirect from "redux/reducers/redirect";

export const RedirectSelector = {
  state: (state) => state[redirect.name],
  suitability: (state) => RedirectSelector.state(state).suitability,
  primaryMarket: (state) => RedirectSelector.state(state)["primary-market"],
  structureNoteMarket: (state) => RedirectSelector.state(state)["structure-note-market"],
  secondaryMarket: (state) => RedirectSelector.state(state)["secondary-market"],
};
